import React from 'react';
import { Search } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
import { Screen } from '../../types';
interface SearchBarProps {
  readOnly?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
}
export function SearchBar({
  readOnly = false,
  autoFocus = false,
  placeholder = 'Search for products...'
}: SearchBarProps) {
  const {
    navigate
  } = useNavigation();
  return <div className="relative w-full" onClick={() => readOnly && navigate(Screen.SEARCH)} data-id="element-154">
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none" data-id="element-155">
        <Search className="h-5 w-5 text-gray-400" data-id="element-156" />
      </div>
      <input type="text" readOnly={readOnly} autoFocus={autoFocus} className="block w-full pl-10 pr-4 py-3 bg-white border border-gray-100 rounded-xl text-sm shadow-sm focus:ring-1 focus:ring-primary focus:border-primary outline-none transition-all" placeholder={placeholder} data-id="element-157" />
    </div>;
}